import React from 'react';
import { Form, Input, Select, Switch, Row, Col } from 'antd';
import { HrAccountMapping, HrMappingType } from '../types';

const { Option } = Select;

const HR_MAPPING_LABELS: Record<HrMappingType, string> = {
  SALARY_EXPENSE: 'Salary Expense (Dr)',
  ALLOWANCES_EXPENSE: 'Allowances Expense (Dr)',
  BONUS_EXPENSE: 'Bonus Expense (Dr)',
  PAYE_TAX_LIABILITY: 'PAYE Tax Liability (Cr)',
  NSSF_EMPLOYER_EXPENSE: 'NSSF Employer Expense (Dr)',
  NSSF_EMPLOYEE_LIABILITY: 'NSSF Employee Liability (Cr)',
  NHIF_EMPLOYEE_LIABILITY: 'NHIF Employee Liability (Cr)',
  NET_PAY_LIABILITY: 'Net Pay Liability (Cr)',
  SALARY_ADVANCE_ASSET: 'Salary Advance Asset (Dr)',
};

interface HrAccountMappingFormProps {
  form: ReturnType<typeof Form.useForm>[0];
  initial?: Partial<HrAccountMapping>;
}

const HrAccountMappingForm: React.FC<HrAccountMappingFormProps> = ({ form, initial }) => {
  React.useEffect(() => {
    if (initial) form.setFieldsValue(initial);
  }, [form, initial]);

  return (
    <Form form={form} layout="vertical">
      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Form.Item name="mappingType" label="Mapping Type" rules={[{ required: true }]}>
            <Select placeholder="Select payroll component">
              {Object.entries(HR_MAPPING_LABELS).map(([value, label]) => (
                <Option key={value} value={value}>{label}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item name="branch" label="Branch" initialValue="HQ" rules={[{ required: true }]}>
            <Input placeholder="Branch code e.g. HQ" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <Form.Item name="glNo" label="GL Account No." rules={[{ required: true }]}>
            <Input placeholder="6-char GL number" maxLength={6} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item name="acNo" label="Account No.">
            <Input placeholder="Optional AC number" maxLength={6} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8}>
          <Form.Item name="name" label="Description">
            <Input placeholder="Account description" />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="active" label="Active" valuePropName="checked" initialValue={true}>
        <Switch />
      </Form.Item>
    </Form>
  );
};

export default HrAccountMappingForm;
